import firebase from 'firebase';

let config = {
    apiKey: "AIzaSyC1uXP3zSliqPd4BmQO9couGbo2oH362ww",
    authDomain: "https://reactp01-ad334.firebaseapp.com",
    databaseURL: "https://reactp01-ad334.firebaseio.com",
    storageBucket: "reactp01-ad334.appspot.com",
    messagingSenderId: "318143023187"
}
let fire = firebase.initializeApp(config);

export default fire;


// WEBPACK FOOTER //
// ./src/fire.js